import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Image from "gatsby-image"

import "./index.scss"

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      resume: allFile(filter: { extension: { eq: "pdf" } }) {
        edges {
          node {
            publicURL
          }
        }
      }
      avatar: file(absolutePath: { regex: "/profile_pic.jpg/" }) {
        childImageSharp {
          fixed(quality: 100, width: 72, height: 72) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      site {
        siteMetadata {
          author
          introduction
          social {
            github
          }
        }
      }
    }
  `)

  const { author, introduction, social } = data.site.siteMetadata
  return (
    <div className="bio">
      <div className="author">
        <div className="author-description">
          <Image
            className="author-image"
            fixed={data.avatar.childImageSharp.fixed}
            alt={author}
            style={{
              borderRadius: `100%`,
            }}
          />
          <div className="author-name">
            <Link to={"/"} className="author-name-content">
              <span>@{author}</span>
            </Link>
            <div
              className="author-introduction"
              dangerouslySetInnerHTML={{ __html: introduction }}
            ></div>
            <p className="author-socials">
              {social.github && (
                <a className="bio-a" href={`${social.github}`} target="__blank">
                  <i className="fab fa-github fa-bio-common"></i> GitHub
                </a>
              )}
              {/* {
                <a className="bio-a" href={`${data.resume.edges[0].node.publicURL}`} target="__blank">
                  <i className="fa fa-file fa-bio-common"></i> Resume
                </a>
              } */}
              {/* {social.medium && (
                <a href={`https://medium.com/${social.medium}`}>Medium</a>
              )}
              {social.twitter && (
                <a href={`https://twitter.com/${social.twitter}`}>Twitter</a>
              )}
              {social.facebook && (
                <a href={`https://www.facebook.com/${social.facebook}`}>
                  Facebook
                </a>
              )} */}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Bio
